<template>
  <svg width="76" height="120" viewBox="0 0 76 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.166718" width="75" height="120" rx="8" fill="#F7F7F7"/>
    <rect x="6.16672" y="6" width="8" height="8" rx="4" fill="#47BC00"/>
    <rect x="61.1667" y="6" width="8" height="8" rx="4" fill="#D1D6DF"/>
    <rect x="28.1667" y="7" width="20" height="6" rx="3" fill="#D1D6DF"/>
    <rect x="6.16672" y="20" width="30" height="30" rx="4" fill="white"/>
    <rect x="6.16672" y="54" width="30" height="30" rx="4" fill="white"/>
    <rect x="6.16672" y="88" width="63" height="10" rx="4" fill="white"/>
    <rect x="6.16672" y="102" width="63" height="10" rx="4" fill="white"/>
    <rect x="39.1667" y="20" width="30" height="30" rx="4" fill="white"/>
    <rect x="39.1667" y="54" width="30" height="30" rx="4" fill="white"/>
    <rect x="10.1667" y="24" width="16" height="4" rx="2" fill="#2C303B"/>
    <rect x="43.1667" y="24" width="16" height="4" rx="2" fill="#2C303B"/>
    <rect x="10.1667" y="58" width="16" height="4" rx="2" fill="#2C303B"/>
    <rect x="10.1667" y="91" width="16" height="4" rx="2" fill="#2C303B"/>
    <rect x="10.1667" y="105" width="16" height="4" rx="2" fill="#2C303B"/>
    <rect x="43.1667" y="58" width="16" height="4" rx="2" fill="#2C303B"/>
    <rect x="10.1667" y="33" width="22" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="43.1667" y="33" width="22" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="10.1667" y="67" width="22" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="30.1667" y="92" width="35" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="30.1667" y="106" width="35" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="43.1667" y="67" width="22" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="10.1667" y="37" width="22" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="43.1667" y="37" width="22" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="10.1667" y="71" width="22" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="43.1667" y="71" width="22" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="10.1667" y="41" width="12" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="43.1667" y="41" width="12" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="10.1667" y="75" width="12" height="2" rx="1" fill="#D1D6DF"/>
    <rect x="43.1667" y="75" width="12" height="2" rx="1" fill="#D1D6DF"/>
    <g clip-path="url(#clip0_7483_2933)">
    <rect x="0.166718" width="75" height="120" rx="8" fill="#242424"/>
    <rect x="61.1667" y="6" width="8" height="8" rx="4" fill="#9C9C9C"/>
    <rect x="28.1667" y="7" width="20" height="6" rx="3" fill="#9C9C9C"/>
    <rect x="6.16672" y="88" width="63" height="10" rx="4" fill="#333333"/>
    <rect x="6.16672" y="102" width="63" height="10" rx="4" fill="#333333"/>
    <rect x="39.1667" y="20" width="30" height="30" rx="4" fill="#333333"/>
    <rect x="39.1667" y="54" width="30" height="30" rx="4" fill="#333333"/>
    <rect x="43.1667" y="24" width="16" height="4" rx="2" fill="#F5F6F6"/>
    <rect x="43.1667" y="58" width="16" height="4" rx="2" fill="#F5F6F6"/>
    <rect x="43.1667" y="33" width="22" height="2" rx="1" fill="#9C9C9C"/>
    <rect x="30.1667" y="92" width="35" height="2" rx="1" fill="#9C9C9C"/>
    <rect x="30.1667" y="106" width="35" height="2" rx="1" fill="#9C9C9C"/>
    <rect x="43.1667" y="67" width="22" height="2" rx="1" fill="#9C9C9C"/>
    <rect x="43.1667" y="37" width="22" height="2" rx="1" fill="#9C9C9C"/>
    <rect x="43.1667" y="71" width="22" height="2" rx="1" fill="#9C9C9C"/>
    <rect x="43.1667" y="41" width="12" height="2" rx="1" fill="#9C9C9C"/>
    <rect x="43.1667" y="75" width="12" height="2" rx="1" fill="#9C9C9C"/>
    </g>
    <defs>
    <clipPath id="clip0_7483_2933">
    <rect width="37" height="120" fill="white" transform="translate(38.1667)"/>
    </clipPath>
    </defs>
  </svg>
</template>